( function() { 
    'use strict';
    //Image lazy loading
    let images = document.querySelectorAll('img[data-src]');

    // Show the image if reached on viewport
    function showImagesOnView( e ) {        
        for( let i of images ) {
            if( i.getAttribute('src') ) { continue; } // SKIP if already displayed
            
            // Compare the position of image and scroll
            let bounding = i.getBoundingClientRect();
            let isOnView = bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
            
            if( isOnView ) {
                i.setAttribute( 'src', i.dataset.src );
                if( i.getAttribute('data-srcset') ) {
                    i.setAttribute( 'srcset', i.dataset.srcset );
                }
            }
        }
    }

    function getUserLocation() {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => resolve(position.coords),
                    error => reject(error)
                );
            } else {
                reject('Geolocation is not supported by this browser.');
            }
        });
    }

    function getOrCreateErrorSpan(field) {
        let errorSpan = field.nextElementSibling;
        if (!errorSpan || errorSpan.tagName !== 'SPAN') {
            errorSpan = document.createElement('span');
            errorSpan.classList.add('error-message');
            field.parentNode.insertBefore(errorSpan, field.nextSibling);
        }
        return errorSpan;
    }

    function getFieldLabel(fieldName) {
        switch(fieldName) {
            case 'FNAME': return 'First Name';
            case 'LNAME': return 'Last Name';
            case 'EMAIL': return 'Email';
            default: return 'This field';
        }
    }

    function validateEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    }

    /*async function fetchPrayerTimesByLocation(lat, lon) {
        try {
            const response = await fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'action': 'fetch_prayer_times_latlang',
                    'lat': lat,
                    'lon': lon
                })
            });
            const result = await response.json();
            return result.success ? result.data : null;
        } catch (error) {
            console.error('Error fetching prayer times:', error);
        }
    }

    function calculateRemainingTime(prayerTimes) {
        const now = new Date();
        const prayerNames = ['fajr', 'dhuhr', 'asr', 'maghrib', 'isha'];
        let nextPrayerName = '';
        let nextPrayerTime = null;
    
        for (const prayer of prayerNames) {
            const prayerTime = new Date(`${now.toDateString()} ${prayerTimes[prayer]}`);
            if (prayerTime > now) {
                nextPrayerName = prayer;
                nextPrayerTime = prayerTime;
                break;
            }
        }
    
        if (nextPrayerTime) {
            const remainingTime = nextPrayerTime - now;
            const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
            const seconds = Math.floor((remainingTime / 1000) % 60);
            return { nextPrayerName, hours, minutes, seconds };
        }
    
        return null;
    }
    
    async function displayRemainingTime() {
        try {
            const coords = await getUserLocation();
            const prayerTimes = await fetchPrayerTimesByLocation(coords.latitude, coords.longitude);
    
            if (!prayerTimes) return;
    
            setInterval(() => {
                const { nextPrayerName, hours, minutes, seconds } = calculateRemainingTime(prayerTimes);
                document.getElementById('ptime-geo').innerText = `${nextPrayerName.toUpperCase()} in ${hours}h ${minutes}m ${seconds}s`;
            }, 1000);
        } catch (error) {
            console.error('Error:', error);
        }
    }*/


    document.addEventListener("DOMContentLoaded", function(){

        showImagesOnView();
        //Mobile menu trigger
        var mobileMenuTrigger=document.querySelector('.mobile-navtoggle');
        var mobileMenuWrap = document.querySelector('.nav-main-menu-wrap');
        mobileMenuTrigger.addEventListener('click', function(e){
            e.preventDefault();
            document.body.classList.toggle('mobile-menu-active');
            mobileMenuWrap.classList.toggle('active');
        });
        var mobileMenuClose = document.querySelector('.mobile-menu-close');
        if(mobileMenuClose){
            mobileMenuClose.addEventListener('click', function(e){
                e.preventDefault();
                document.body.classList.remove('mobile-menu-active');
                mobileMenuWrap.classList.remove('active');
            });
        }
        
        //Mobile menu sub child click
        // Get all the menu items that have children
        var menuItems = document.querySelectorAll('.menu-item-has-children > a');
        menuItems.forEach(function(menuItem) {
            menuItem.addEventListener('click', function(e) {
                // Check if screen width is below 1024px
                if (window.innerWidth < 1024) {
                    // Prevent the default action (navigation)
                    e.preventDefault();
                    
                    // Toggle the visibility of the submenu
                    var submenu = this.nextElementSibling; // Submenu is the next sibling
                    if (submenu && submenu.classList.contains('sub-menu')) {
                        submenu.classList.toggle('submenu-visible');
                    }
                }
            });
        });

        const date = new Date();

        // Format parts individually
        const weekday = date.toLocaleDateString(undefined, { weekday: 'long' }); // Monday
        const day = date.toLocaleDateString(undefined, { day: 'numeric' }); // 10
        const month = date.toLocaleDateString(undefined, { month: 'short' }); // Feb
        const year = date.toLocaleDateString(undefined, { year: 'numeric' }); // 2025

        // Combine in required format: "Monday, 10 Feb 2025"
        document.getElementById('current-date').textContent = `${weekday}, ${day} ${month} ${year}`;    

        //Show more for top news
        if(document.querySelector('.section-topnews')){
            var topNews = document.querySelectorAll('.top-news.has-hidden');
            var showMoreTopnews = document.querySelector('.show-more-topnews');
            var showLessTopnews = document.querySelector('.show-less-topnews');
            if(showMoreTopnews){
                showMoreTopnews.addEventListener('click',function(e){
                    topNews.forEach(function(topnews) {
                        topnews.classList.remove('hidden');
                    });
                    showLessTopnews.classList.remove('hidden');
                    showMoreTopnews.classList.add('hidden');
                });

                showLessTopnews.addEventListener('click',function(e){
                    topNews.forEach(function(topnews) {
                        topnews.classList.add('hidden');
                    });
                    showLessTopnews.classList.add('hidden');
                    showMoreTopnews.classList.remove('hidden');
                });
            }
        }

        //Function for search popup
        const headerSearchInstances = document.querySelectorAll('.header-search');
        function updateHeaderSearchOverlayState() {
            const anyMobileHeaderSearchOpen = document.querySelector('.header-search--mobile.open');
            document.body.classList.toggle('header-search-open', !!anyMobileHeaderSearchOpen);
        }
        function closeAllHeaderSearch(exceptInstance) {
            headerSearchInstances.forEach((instance) => {
                if (exceptInstance && instance === exceptInstance) {
                    return;
                }
                instance.classList.remove('open');
                const toggle = instance.querySelector('.header-search-toggle');
                const panel = instance.querySelector('.header-search-panel');
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                }
                if (panel) {
                    panel.setAttribute('aria-hidden', 'true');
                }
            });

            updateHeaderSearchOverlayState();
        }

        headerSearchInstances.forEach((instance) => {
            const toggle = instance.querySelector('.header-search-toggle');
            const panel = instance.querySelector('.header-search-panel');
            const input = instance.querySelector('.header-search-input');

            if (!toggle || !panel || !input) {
                return;
            }

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const willOpen = !instance.classList.contains('open');
                closeAllHeaderSearch(instance);
                if (willOpen) {
                    instance.classList.add('open');
                    toggle.setAttribute('aria-expanded', 'true');
                    panel.setAttribute('aria-hidden', 'false');
                    input.focus();
                } else {
                    instance.classList.remove('open');
                    toggle.setAttribute('aria-expanded', 'false');
                    panel.setAttribute('aria-hidden', 'true');
                }

                updateHeaderSearchOverlayState();
            });
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeAllHeaderSearch();
            }
        });

        document.addEventListener('click', (e) => {
            const clickedInsideHeaderSearch = e.target && e.target.closest && e.target.closest('.header-search');
            if (!clickedInsideHeaderSearch) {
                closeAllHeaderSearch();
            }
        });

        //Function for search popup (ajax popup)
        const searchInput = document.getElementById('ajax-search-input');
        const searchResults = document.getElementById('search-popup--results');
        const loadingIcon = document.getElementById('search-loading-icon');
        
        // Header search inputs
        const headerSearchInputs = document.querySelectorAll('.header-search-input');

        var searchPopupTrigger = document.querySelectorAll('.search-popup-trigger');
        var searchPopupClseTrigger = document.querySelector('.search-popup--close');
        var searchPopupWrap = document.querySelector('.search-popup');

        if (searchPopupWrap && searchPopupClseTrigger && searchPopupTrigger && searchPopupTrigger.length) {
            searchPopupTrigger.forEach(function(spt) {
                spt.addEventListener('click', function(e) {
                    e.preventDefault();

                    if (loadingIcon) {
                        loadingIcon.style.display = 'none';
                    }
                    if (searchResults) {
                        searchResults.innerHTML = "";
                    }
                    if (searchInput) {
                        searchInput.value = "";
                    }

                    if (searchPopupWrap.classList.contains('open')) {
                        searchPopupWrap.classList.remove('open');
                    }
                    else{
                        searchPopupWrap.classList.add('open');
                        if (searchInput) {
                            searchInput.focus();
                        }
                    }
                });
            });

            searchPopupClseTrigger.addEventListener('click', function(e){
                e.preventDefault();
                searchPopupWrap.classList.remove('open');
            });
        }

        let controller; // Variable to hold the AbortController instance
        let debounceTimeout;
        function fetchSearchResults(query, resultsContainer) {
            // If there's an ongoing request, abort it
            if (controller) {
                if (loadingIcon) {
                    loadingIcon.style.display = 'none';
                }
                controller.abort();
            }

            // Create a new AbortController for the new request
            controller = new AbortController();
            const signal = controller.signal;
            if (loadingIcon) {
                loadingIcon.style.display = 'block';
            }

            // Perform the fetch request
            fetch(`/wp-admin/admin-ajax.php?action=ajax_search&query=${query}`, { signal })
            .then(response => response.json())
            .then(results => {
                if (loadingIcon) {
                    loadingIcon.style.display = 'none'; // Hide loading icon
                }
                if (results.data.length > 0) {
                    resultsContainer.innerHTML = results.data.map(result => 
                        `<div class="result-item">
                            ${result.image ? `<a href="${result.url}" class="image-wrapper"><img src="${result.image}" loading="lazy"/></a>` :''} 
                            <a href="${result.url}" class="post-title">${result.title}</a>
                        </div>`
                    ).join('');
                } else {
                    resultsContainer.innerHTML = '<div>No results found.</div>';
                }
            })
            .catch(error => {
                if (loadingIcon) {
                    loadingIcon.style.display = 'none'; // Hide loading icon
                }
                if (error.name === 'AbortError') {
                    console.log('Request aborted');
                } else {
                    console.error('Fetch error:', error);
                }
            });            
        }
        // Debouncing function
        function debounceSearch(event, resultsContainer) {
            const query = event.target.value;
            if (query.length >= 3) {
                clearTimeout(debounceTimeout); // Clear previous timeout
                debounceTimeout = setTimeout(() => {
                    fetchSearchResults(query, resultsContainer);
                }, 300); // Wait 300ms after the last keystroke
            } else {
                resultsContainer.innerHTML = '';
            }
        }
        if (searchInput) {
            searchInput.addEventListener('keyup', (e) => debounceSearch(e, searchResults));
        }
        
        // Add event listeners for header search inputs
        headerSearchInputs.forEach(input => {
            const headerSearchPanel = input.closest('.header-search-panel');
            const headerResultsContainer = headerSearchPanel ? headerSearchPanel.querySelector('.search-popup--results') : null;
            
            if (headerResultsContainer) {
                input.addEventListener('keyup', (e) => debounceSearch(e, headerResultsContainer));
            }
        });

        //Mailchimp form validation
        const forms = document.querySelectorAll(".mc4wp-form"); // Adjust to your form selector
        forms.forEach((form)=>{
            // Disable browser's default HTML5 validation
            form.setAttribute('novalidate', 'novalidate');
            
            let fields = form.querySelectorAll(".subscription-form-field");
            const termsCheckbox = form.querySelector("input[name='subscription_terms_agree']");
            form.addEventListener('submit',function(event) {
                let isValid = true;
                fields.forEach(function(field) {
                    const fieldName = field.getAttribute("name");
                    const errorSpan = getOrCreateErrorSpan(field);
        
                    if (!field.value.trim()) {
                        isValid = false;
                        errorSpan.textContent = `${getFieldLabel(fieldName)} is required.`;
                        field.classList.add("error");
                    } else if (fieldName === "EMAIL" && !validateEmail(field.value.trim())) {
                        isValid = false;
                        errorSpan.textContent = "Please enter a valid email address.";
                        field.classList.add("error");
                    } else {
                        errorSpan.textContent = ''; // Clear error message
                        field.classList.remove("error");
                    }
                });

                let termsErrorSpan = getOrCreateErrorSpan(termsCheckbox);
                if (!termsCheckbox.checked) {
                    isValid = false;
                    termsErrorSpan.textContent = "You must agree to the terms and conditions.";
                    termsCheckbox.classList.add("error");
                } else {
                    termsErrorSpan.textContent = ''; // Clear error message
                    termsCheckbox.classList.remove("error");
                }

                if (!isValid) {
                    event.preventDefault(); // Prevent form submission if validation fails
                }
            });

            fields.forEach(function(field) {
                field.addEventListener("input", function() {
                    const errorSpan = getOrCreateErrorSpan(field);
                    errorSpan.textContent = ''; // Clear error message on input
                    field.classList.remove("error");
                });
            });

            termsCheckbox.addEventListener("change", function() {
                const errorSpan = getOrCreateErrorSpan(termsCheckbox);
                if (termsCheckbox.checked) {
                    errorSpan.textContent = ''; // Clear error message when checked
                    termsCheckbox.classList.remove("error");
                }
            });
        }); 

        //Function for search popup
        var subscribePopupTrigger = document.querySelector('.subscribe-popup a');
        var subscribePopupTrigger2 = document.querySelector('.footer-subscription-trigger');
        var subscribePopupClseTrigger = document.querySelector('.subscription-popup--close');
        var subscribePopupWrap = document.querySelector('.subscription-popup');
        
        if(subscribePopupTrigger){
            subscribePopupTrigger.addEventListener('click', function(e) {
                e.preventDefault();
                // Toggle the visibility of the submenu
                if (subscribePopupWrap.classList.contains('open')) {
                    subscribePopupWrap.classList.remove('open');
                }
                else{
                    subscribePopupWrap.classList.add('open');
                }
            });
        }
        if(subscribePopupTrigger2){
            subscribePopupTrigger2.addEventListener('click', function(e) {
                e.preventDefault();
                // Toggle the visibility of the submenu
                if (subscribePopupWrap.classList.contains('open')) {
                    subscribePopupWrap.classList.remove('open');
                }
                else{
                    subscribePopupWrap.classList.add('open');
                }
            });
        }
        subscribePopupClseTrigger.addEventListener('click', function(e){
            subscribePopupWrap.classList.remove('open');
        });

        window.addEventListener('resize', function() {
            if (window.innerWidth > 1024) {
                if (document.body.classList.contains('mobile-menu-active')) {
                    document.body.classList.remove('mobile-menu-active');
                    mobileMenuWrap.classList.remove('active');
                }
            }
        });

        const ourTeamBlock = document.querySelector('.our-team-block');
        if(ourTeamBlock){
            const teamMembres = document.querySelectorAll('.team-card');
            teamMembres.forEach((titem)=>{
                const moreLink=titem.querySelector('.trigger-more');
                const moreContent=titem.querySelector('.about-more-team');
                moreLink.addEventListener("click",function(){
                    if(!moreContent.classList.contains('open')){
                        moreLink.textContent = moreLink.dataset.toggletext;
                        moreContent.classList.add('open');
                    }
                    else{
                        moreLink.textContent = moreLink.dataset.text;
                        moreContent.classList.remove('open');
                    }                
                })
            });
        }

        const prayerTimeDay = document.querySelectorAll('.prayer-time-day');
        if(prayerTimeDay){
            prayerTimeDay.forEach((ptd)=>{
                let loc=ptd.getAttribute('data-location');
                let pthtml=ptd.querySelector('.prayer-time-table');

                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body:new URLSearchParams({
                        action:'fetch_prayer_times_today',
                        location: loc
                    })
                };

                fetch(ajaxurl,requestOptions)
                .then((response) => response.text())
                .then((result) => {
                    var dataResult=JSON.parse(result);
                    var data=dataResult.data;
                    var d=new Date(data.date_for);
                    var dd=d.getDate();
                    var mm=d.getMonth()+1;
                    var yy=d.getFullYear();
                    var newdate=dd+"-"+mm+"-"+yy;

                    pthtml.innerHTML=`<div class="flex flex-row md:flex-col w-full md:w-2/12">
                        <div class="bg-slate-200 font-heading font-medium text-h4 p-4 w-6/12 md:w-full">Day</div>
                        <div class="bg-slate-100 font-medium text-base p-4 w-6/12 md:w-full">${newdate}</div>
                    </div>
                    <div class="flex flex-row md:flex-col w-full md:w-2/12">
                        <div class="bg-slate-200 font-heading font-medium text-h4 p-4 w-6/12 md:w-full">Fajr</div>
                        <div class="bg-slate-100 font-medium text-base p-4 w-6/12 md:w-full">${data.fajr}</div>
                    </div>
                    <div class="flex flex-row md:flex-col w-full md:w-2/12">
                        <div class="bg-slate-200 font-heading font-medium text-h4 p-4 w-6/12 md:w-full">Dhuhr</div>
                        <div class="bg-slate-100 font-medium text-base p-4 w-6/12 md:w-full">${data.dhuhr}</div>
                    </div>
                    <div class="flex flex-row md:flex-col w-full md:w-2/12">
                        <div class="bg-slate-200 font-heading font-medium text-h4 p-4 w-6/12 md:w-full">Asr</div>
                        <div class="bg-slate-100 font-medium text-base p-4 w-6/12 md:w-full">${data.asr}</div>
                    </div>
                    <div class="flex flex-row md:flex-col w-full md:w-2/12">
                        <div class="bg-slate-200 font-heading font-medium text-h4 p-4 w-6/12 md:w-full">Maghrib</div>
                        <div class="bg-slate-100 font-medium text-base p-4 w-6/12 md:w-full">${data.maghrib}</div>
                    </div>
                    <div class="flex flex-row md:flex-col w-full md:w-2/12">
                        <div class="bg-slate-200 font-heading font-medium text-h4 p-4 w-6/12 md:w-full">Isha</div>
                        <div class="bg-slate-100 font-medium text-base p-4 w-6/12 md:w-full">${data.isha}</div>
                    </div>`;
                })            
                .catch((error) => console.error(error));            
            })
        }

        const prayerTimeMonth = document.querySelectorAll('.prayer-time-month');
        if(prayerTimeMonth){
            prayerTimeMonth.forEach((ptd)=>{
                let loc=ptd.getAttribute('data-location');
                let pthtml=ptd.querySelector('.prayer-time-month-today');
                let pmonthdatahtml = ptd.querySelector('.prayer-time-month-data');
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body:new URLSearchParams({
                        action:'fetch_prayer_times_monthly',
                        location: loc
                    })
                };

                fetch(ajaxurl,requestOptions)
                .then((response) => response.text())
                .then((result) => {
                    var dataResult=JSON.parse(result);
                    var data=dataResult.data;
                    console.log(data);
                    var d=new Date(data[0].date_for);
                    var dd=d.getDate();
                    var mm=d.getMonth()+1;
                    var yy=d.getFullYear();
                    var newdate=dd+"-"+mm+"-"+yy;
                    let todayData = data[0];
                    let tfajrArr = todayData.fajr.split(" ");
                    let tdhuhrArr = todayData.dhuhr.split(" ");
                    let tasrArr = todayData.asr.split(" ");
                    let tmaghrib = todayData.maghrib.split(" ");
                    let tIsha = todayData.isha.split(" ");

                    /*pthtml.innerHTML=`<div class="w-full md:w-auto flex-1 flex-grow bg-primary text-center p-4">
                        <div class="text-base text-white mb-4">Maghrib</div>
                        <div class="text-h2 text-white font-semibold mb-4 text-center">${tmaghrib[0]} <span class="text-sm uppercase">${tmaghrib[1]}</div>
                        <div class="text-sm text-white text-center">3 hours 8 minutes to Maghrib</div>
                    </div>`;*/

                    pthtml.innerHTML=`<div class="w-full md:w-auto flex-1 flex-grow bg-white p-4">
                        <div class="text-base text-grey-dark mb-4">Fajr</div>
                        <div class="text-h2 text-primary font-semibold text-center">${tfajrArr[0]} <span class="text-sm uppercase">${tfajrArr[1]}</span></div>
                    </div>
                    <div class="w-full md:w-auto flex-1 flex-grow bg-white p-4">
                        <div class="text-base text-grey-dark mb-4">Dhuhr</div>
                        <div class="text-h2 text-primary font-semibold text-center">${tdhuhrArr[0]} <span class="text-sm uppercase">${tdhuhrArr[1]}</span></div>
                    </div>
                    <div class="w-full md:w-auto flex-1 flex-grow bg-white p-4">
                        <div class="text-base text-grey-dark mb-4">Asr</div>
                        <div class="text-h2 text-primary font-semibold text-center">${tasrArr[0]} <span class="text-sm uppercase">${tasrArr[1]}</div>
                    </div>
                    <div class="w-full md:w-auto flex-1 flex-grow bg-white p-4">
                        <div class="text-base text-grey-dark mb-4">Asr</div>
                        <div class="text-h2 text-primary font-semibold text-center">${tmaghrib[0]} <span class="text-sm uppercase">${tmaghrib[1]}</div>
                    </div>
                    <div class="w-full md:w-auto flex-1 flex-grow bg-white p-4">
                        <div class="text-base text-grey-dark mb-4">Isha</div>
                        <div class="text-h2 text-primary font-semibold text-center">${tIsha[0]} <span class="text-sm uppercase">${tIsha[1]}</div>
                    </div>`;

                    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

                    data.forEach((item)=>{
                        var d = new Date(item.date_for);
                        var day=('0' + d.getDate()).slice(-2);
                        var dayName = days[d.getDay()];
                        pmonthdatahtml.innerHTML +=`
                            <tr>
                                <td class="px-4 py-3 border border-slate-200">${day}</td>
                                <td class="px-4 py-3 border border-slate-200">${dayName}</td>
                                <td class="px-4 py-3 border border-slate-200">${item.fajr}</td>
                                <td class="px-4 py-3 border border-slate-200">${item.dhuhr}</td>
                                <td class="px-4 py-3 border border-slate-200">${item.asr}</td>
                                <td class="px-4 py-3 border border-slate-200">${item.maghrib}</td>
                                <td class="px-4 py-3 border border-slate-200">${item.isha}</td>
                            </tr>
                        `;
                    });
                })            
                .catch((error) => console.error(error));            
            })
        }
    });

    //Sticky navigation class
    var menu = document.querySelector('.nav-main-menu-wrap');
    var stickyClass = 'sticky-nav';
    var stickyOffset = menu.offsetTop;
    window.addEventListener('scroll', function() {
        if (document.documentElement.scrollTop > stickyOffset) {
            menu.classList.add(stickyClass); // Add sticky class
        } else {
            menu.classList.remove(stickyClass); // Remove sticky class
        }
        showImagesOnView();
    }, false);
})()

        // Formidable Forms Professional Validation
        const formidableForms = document.querySelectorAll('.frm_forms form');
        
        // IMMEDIATE CHECK: If success message already exists on page load, hide titles
        const existingSuccessMessage = document.querySelector('.frm_message');
        if (existingSuccessMessage) {
            hideTitlesImmediately();
            startRedirectCountdown();
        }
        
        // Function to force hide titles
        function hideTitlesImmediately() {
            // Multiple selectors to catch all possible title elements
            const titleSelectors = [
                '.primary-title',
                '#h-express-your-interest',
                '.wp-block-heading.primary-title',
                'h2#h-express-your-interest',
                '.secondary-title',
                'p.secondary-title'
            ];
            
            titleSelectors.forEach(selector => {
                const elements = document.querySelectorAll(selector);
                elements.forEach(element => {
                    if (element) {
                        element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; position: absolute !important; left: -9999px !important;';
                        element.classList.add('hide-title');
                        element.remove(); // Completely remove from DOM
                    }
                });
            });
            
            // Also add class to page content
            const pageContent = document.querySelector('.page-content');
            if (pageContent) {
                pageContent.classList.add('form-submitting-state');
            }
        }
        
        // Function to start redirect countdown
        function startRedirectCountdown() {
            const successMessage = document.querySelector('.frm_message');
            if (successMessage && !document.getElementById('countdown-timer')) {
                // Silent redirect - no message, just countdown and redirect
                let countdown = 7;
                
                const countdownInterval = setInterval(function() {
                    countdown--;
                    
                    if (countdown <= 0) {
                        clearInterval(countdownInterval);
                        // Redirect to homepage
                        window.location.href = window.location.origin + '/';
                    }
                }, 1000);
            }
        }
        
        formidableForms.forEach((form) => {
            // Disable browser's default HTML5 validation
            form.setAttribute('novalidate', 'novalidate');
            
            // Create loading overlay
            const loadingOverlay = document.createElement('div');
            loadingOverlay.className = 'form-loading-overlay';
            loadingOverlay.innerHTML = `
                <div class="form-loader">
                    <div class="form-loader-spinner"></div>
                    <div class="form-loader-text">Submitting...</div>
                </div>
            `;
            
            // Add loading overlay to form container
            const formContainer = form.closest('.frm_forms');
            if (formContainer) {
                formContainer.style.position = 'relative';
                formContainer.appendChild(loadingOverlay);
            }
            
            const submitButton = form.querySelector('.frm_button_submit');
            if (!submitButton) return;
            
            // Initially disable the submit button
            submitButton.disabled = true;
            
            // Get all required fields
            const requiredFields = form.querySelectorAll('[aria-required="true"]');
            
            // Validation functions
            function validateEmailField(value) {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
                return emailPattern.test(value);
            }
            
            function validatePhoneField(value) {
                // Remove spaces and check if it's a valid phone number
                const cleanPhone = value.replace(/\s+/g, '');
                return cleanPhone.length >= 7 && cleanPhone.length <= 15 && /^\d+$/.test(cleanPhone);
            }
            
            function getOrCreateFormErrorSpan(field) {
                const fieldContainer = field.closest('.frm_form_field');
                let errorSpan = fieldContainer.querySelector('.frm_error_style');
                
                if (!errorSpan) {
                    errorSpan = document.createElement('span');
                    errorSpan.classList.add('frm_error_style');
                    fieldContainer.appendChild(errorSpan);
                }
                
                return errorSpan;
            }
            
            function clearError(field) {
                const errorSpan = getOrCreateFormErrorSpan(field);
                errorSpan.textContent = ''; // This will hide the span via CSS :empty selector
                field.classList.remove('frm_error');
            }
            
            function showError(field, message) {
                const errorSpan = getOrCreateFormErrorSpan(field);
                errorSpan.textContent = message; // This will show the span via CSS :not(:empty)
                field.classList.add('frm_error');
            }
            
            function validateField(field) {
                const fieldType = field.type;
                const fieldValue = field.value.trim();
                const isRequired = field.getAttribute('aria-required') === 'true';
                const fieldLabel = field.closest('.frm_form_field').querySelector('.frm_primary_label');
                const labelText = fieldLabel ? fieldLabel.textContent.replace('*', '').trim() : 'This field';
                
                // Remove previous error/valid state
                field.classList.remove('frm_error', 'frm_valid');
                
                // Check if field is empty and required
                if (isRequired && !fieldValue) {
                    showError(field, `${labelText} cannot be blank.`);
                    return false;
                }
                
                // Validate email
                if (fieldType === 'email' && fieldValue) {
                    if (!validateEmailField(fieldValue)) {
                        showError(field, 'Please enter a valid email address.');
                        return false;
                    }
                }
                
                // Validate phone
                if (fieldType === 'tel' && fieldValue) {
                    if (!validatePhoneField(fieldValue)) {
                        showError(field, 'Please enter a valid phone number (7-15 digits).');
                        return false;
                    }
                }
                
                // Field is valid - clear error
                clearError(field);
                if (fieldValue) {
                    field.classList.add('frm_valid');
                }
                
                return true;
            }
            
            function checkFormValidity() {
                let allValid = true;
                
                requiredFields.forEach((field) => {
                    const fieldValue = field.value.trim();
                    const fieldType = field.type;
                    
                    if (!fieldValue) {
                        allValid = false;
                        return;
                    }
                    
                    // Additional validation for specific field types
                    if (fieldType === 'email' && !validateEmailField(fieldValue)) {
                        allValid = false;
                    }
                    
                    if (fieldType === 'tel' && !validatePhoneField(fieldValue)) {
                        allValid = false;
                    }
                });
                
                // Enable or disable submit button
                submitButton.disabled = !allValid;
            }
            
            // Real-time validation on input
            requiredFields.forEach((field) => {
                // Validate on blur (when user leaves the field)
                field.addEventListener('blur', function() {
                    validateField(this);
                    checkFormValidity();
                });
                
                // Check form validity on input (for enabling/disabling button)
                field.addEventListener('input', function() {
                    // Clear error on input
                    if (this.classList.contains('frm_error')) {
                        clearError(this);
                    }
                    
                    checkFormValidity();
                });
                
                // For select fields
                if (field.tagName === 'SELECT') {
                    field.addEventListener('change', function() {
                        validateField(this);
                        checkFormValidity();
                    });
                }
            });
            
            // Form submission validation
            form.addEventListener('submit', function(event) {
                let isFormValid = true;
                
                requiredFields.forEach((field) => {
                    if (!validateField(field)) {
                        isFormValid = false;
                    }
                });
                
                if (!isFormValid) {
                    event.preventDefault();
                    
                    // Scroll to first error
                    const firstError = form.querySelector('.frm_error');
                    if (firstError) {
                        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        firstError.focus();
                    }
                } else {
                    // Form is valid - show loading state
                    const formCont = form.closest('.frm_forms');
                    const pageContent = document.querySelector('.page-content');
                    
                    if (formCont) {
                        const loadingOverlay = formCont.querySelector('.form-loading-overlay');
                        if (loadingOverlay) {
                            loadingOverlay.classList.add('active');
                        }
                        formCont.classList.add('form-submitting');
                    }
                    
                    // Hide titles during submission
                    if (pageContent) {
                        pageContent.classList.add('form-submitting-state');
                    }
                    
                    // Disable submit button
                    submitButton.disabled = true;
                    submitButton.textContent = 'SUBMITTING...';
                }
            });
            
            // Better detection for Formidable Forms success - multiple methods
            // Method 1: Check for .frm_message appearance
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            const successMessage = node.classList && node.classList.contains('frm_message') ? node : node.querySelector('.frm_message');
                            
                            if (successMessage) {
                                handleFormSuccess();
                                observer.disconnect();
                            }
                        }
                    });
                });
            });
            
            // Observe the form container for success message
            const formContainerObserver = form.closest('.frm_forms');
            if (formContainerObserver) {
                observer.observe(formContainerObserver, {
                    childList: true,
                    subtree: true
                });
            }
            
            // Method 2: Polling fallback
            let checkCount = 0;
            const maxChecks = 20; // Check for 10 seconds (20 * 500ms)
            
            const checkForSuccess = setInterval(function() {
                checkCount++;
                const successMessage = document.querySelector('.frm_message');
                
                if (successMessage && successMessage.offsetParent !== null) {
                    clearInterval(checkForSuccess);
                    handleFormSuccess();
                }
                
                if (checkCount >= maxChecks) {
                    clearInterval(checkForSuccess);
                }
            }, 500);
            
            // Function to handle successful submission
            function handleFormSuccess() {
                console.log('Form submitted successfully!');
                
                // Hide loader
                const formCont = form.closest('.frm_forms');
                
                if (formCont) {
                    const loadingOverlay = formCont.querySelector('.form-loading-overlay');
                    if (loadingOverlay) {
                        loadingOverlay.classList.remove('active');
                    }
                }
                
                // Use the aggressive title hiding function
                hideTitlesImmediately();
                
                // Start redirect countdown
                startRedirectCountdown();
            }
            
            // Initial check on page load
            checkFormValidity();
        });
